<template>
  <div>
    <h4 class="mb-1">
      {{ title }}
    </h4>
    <b-alert
      v-if="errorText"
      show
      variant="danger"
    >
      {{ errorText }}
    </b-alert>
    <div class="d-flex mb-1">
      <b-form-select
        v-model="status"
        :options="statusOptions"
        class="w-25 mr-1"
        @change="fetch"
      />
    </div>
    <b-table
      :items="rows"
      :fields="fields"
      :busy="loading"
      striped
      responsive
      empty-text="Заявок нет"
    >
      <template #cell(result)="data">
        {{ (data.item.result && data.item.result.name) || data.item.result_id }}
      </template>
      <template #cell(actions)="data">
        <b-button
          v-if="data.item.status === 'PENDING' || data.item.status === 'ADMIN_REVIEW'"
          size="sm"
          variant="outline-success"
          class="mr-50"
          @click="resolve(data.item, 'ATTACHED')"
        >
          Привязать
        </b-button>
        <b-button
          v-if="data.item.status === 'PENDING' || data.item.status === 'ADMIN_REVIEW'"
          size="sm"
          variant="outline-danger"
          @click="resolve(data.item, 'REJECTED')"
        >
          Отклонить
        </b-button>
      </template>
      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner small /> Загрузка...
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import {
  BAlert,
  BButton,
  BFormSelect,
  BSpinner,
  BTable,
} from 'bootstrap-vue'
import identityApi from '@/services/identity-api.service'

export default {
  name: 'ResultRequestsPage',
  components: {
    BAlert,
    BButton,
    BFormSelect,
    BSpinner,
    BTable,
  },
  props: {
    mode: { type: String, default: 'claims' },
  },
  data() {
    return {
      loading: false,
      errorText: '',
      status: '',
      rows: [],
      statusOptions: [
        { value: '', text: 'Все статусы' },
        { value: 'PENDING', text: 'Новые' },
        { value: 'ADMIN_REVIEW', text: 'На проверке' },
        { value: 'ACCEPTED', text: 'Принятые' },
        { value: 'REJECTED', text: 'Отклонённые' },
        { value: 'EXPIRED', text: 'Истёкшие' },
      ],
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'type', label: 'Тип' },
        { key: 'status', label: 'Статус' },
        { key: 'result', label: 'Результат' },
        { key: 'requesterLabel', label: 'Кто запросил' },
        { key: 'targetLabel', label: 'Кому / владелец' },
        { key: 'actions', label: '' },
      ],
    }
  },
  computed: {
    title() {
      if (this.mode === 'suggestions') return 'Предложения результатов'
      if (this.mode === 'conflicts') return 'Конфликты владения'
      return 'Запросы на привязку'
    },
  },
  created() {
    this.fetch()
  },
  methods: {
    personLabel(user) {
      if (!user) return '—'
      const fio = [user.surname, user.name].filter(Boolean).join(' ')
      const type = user.account_type ? ` · ${user.account_type}` : ''
      return `${fio || 'Пользователь'} #${user.id}${type}`
    },
    mapRow(item) {
      return {
        ...item,
        requesterLabel: this.personLabel(item.requester),
        targetLabel: this.personLabel(item.currentOwner || item.targetUser),
      }
    },
    async fetch() {
      this.loading = true
      this.errorText = ''
      try {
        let api = identityApi.getClaims
        if (this.mode === 'suggestions') {
          api = identityApi.getSuggestions
        } else if (this.mode === 'conflicts') {
          api = identityApi.getConflicts
        }
        const { data } = await api({ status: this.status || undefined, maxResultCount: 50 })
        this.rows = (data.rows || []).map(this.mapRow)
      } catch (e) {
        this.errorText = e.response?.data?.message || 'Ошибка загрузки'
      } finally {
        this.loading = false
      }
    },
    async resolve(item, resolution) {
      const attach = resolution === 'ATTACHED'
      const confirmed = await this.$bvModal.msgBoxConfirm(
        attach ? 'Привязать результат к выбранному профилю?' : 'Отклонить заявку?',
        {
          title: attach ? 'Привязка' : 'Отклонение',
          okTitle: attach ? 'Привязать' : 'Отклонить',
          cancelTitle: 'Отмена',
          okVariant: attach ? 'success' : 'danger',
          centered: true,
        },
      )
      if (!confirmed) return
      try {
        if (this.mode === 'conflicts') {
          await identityApi.resolveConflict(item.id, resolution === 'ATTACHED' ? 'TRANSFER' : resolution)
        } else {
          await identityApi.resolveClaim(item.id, resolution)
        }
        this.fetch()
      } catch (e) {
        this.errorText = e.response?.data?.message || 'Не удалось обработать заявку'
      }
    },
  },
}
</script>
